import { NotesParent } from '../../../components/communicationBar/Notes';
import NotesEditingForm from '../components/notes/NotesEditingForm';

interface IOpenNotesDialog {
  clientId: string;
  clientName?: string;
  contactId?: string;
  contactName?: string;
  isClient?: boolean;
  openDialog: (options: { children: React.ReactNode }) => void;
  closeDialog: () => void;
}
const openNotesFormDialog = ({
  clientId,
  clientName,
  contactId,
  contactName,
  isClient,
  openDialog,
  closeDialog,
}: IOpenNotesDialog) => {
  const parent = isClient ? NotesParent.CLIENT : NotesParent.CLIENTCONTACT;

  openDialog({
    children: (
      <NotesEditingForm
        parentId={clientId}
        parent={parent}
        isClient={isClient}
        onCancel={closeDialog}
        clientName={clientName}
        clientContactId={contactId}
        clientContactName={contactName}
      />
    ),
  });
};
export default openNotesFormDialog;
